import { Injectable } from '@angular/core';
import { NotifyService } from "@abp/notify/notify.service.d";
import { FileResponse } from "shared/service-proxies/service-proxies";
import { LocalizationService } from '@abp/localization/localization.service.d';
import { Observable } from 'rxjs';

@Injectable()
export class ReportDownloadService {

    constructor(
        //private _notifyService: NotifyService,
        //private _localizationService: LocalizationService
    )
    {
    }

    /**
     * Displays an alert when report processing starts
     * Displays an alert when report processing finishes and download starts
     * Displays an alert when an error happens
     * @param observableFile
     */
    public downloadReport(observableFile: Observable<FileResponse>): void {
        //this._notifyService.info(
        //    this._localizationService.localize("ProcessingReportForDownload", "ServiceDelivery"));

        try {
            observableFile
                .subscribe(fileResponse => {
                    const element = document.createElement('a');

                    element.href = URL.createObjectURL(fileResponse.data);
                    element.download = fileResponse.fileName;
                    document.body.appendChild(element);
                    element.click();

                    //this._notifyService.success(
                    //    this._localizationService.localize("ReportProcessed", "ServiceDelivery"));
                });
        } catch (e) {
            if (console !== null) {
                console.log(e.message);
            }
            //this._notifyService.error(
            //    this._localizationService.localize("ReportFailed", "ServiceDelivery"));
        }
    }
}
